export default {
  SET_FACEBOOK_SETTINGS: "SET_FACEBOOK_SETTINGS",
  SET_FACEBOOK_CONVERSION_STATUS: "SET_FACEBOOK_CONVERSION_STATUS",
  SET_FACEBOOK_CONVERSION_SETTING_STATUS: "SET_FACEBOOK_CONVERSION_SETTING_STATUS",
  GET_FACEBOOK_SETTINGS: "GET_FACEBOOK_SETTINGS",
  GET_FACEBOOK_DA_SETTINGS: "GET_FACEBOOK_DA_SETTINGS",
  GET_FACEBOOK_API_TOKEN: "GET_FACEBOOK_API_TOKEN",
  GET_FACEBOOK_BUSINESS_LIST: "GET_FACEBOOK_BUSINESS_LIST",
  GET_FACEBOOK_ADS_ACCOUNT_LIST: "GET_FACEBOOK_ADS_ACCOUNT_LIST",
  GET_FACEBOOK_PIXEL_CODE_LIST: "GET_FACEBOOK_PIXEL_CODE_LIST",
  GET_FACEBOOK_PIXEL_AGENCIES: "GET_FACEBOOK_PIXEL_AGENCIES",
  GET_FACEBOOK_CONVERSION_LAST_SENT: "GET_FACEBOOK_CONVERSION_LAST_SENT",
  GET_FACEBOOK_CRM_CONVERSION_LAST_SENT: "GET_FACEBOOK_CRM_CONVERSION_LAST_SENT",
  GET_FACEBOOK_CONVERSION_SETTING_BY_PIPELINE: "GET_FACEBOOK_CONVERSION_SETTING_BY_PIPELINE",
  GET_FACEBOOK_ADS_ACCOUNT_AGENCIES: "GET_FACEBOOK_ADS_ACCOUNT_AGENCIES",
  INVITE_FACEBOOK_ADS_ACCOUNT: "INVITE_FACEBOOK_ADS_ACCOUNT",
  INVITE_FACEBOOK_PIXELS: "INVITE_FACEBOOK_PIXELS",
  SYNC_FACEBOOK_SETTING_WITH_RDYNAMIC: "SYNC_FACEBOOK_SETTING_WITH_RDYNAMIC",
  SYNC_FACEBOOK_SETTING_WITH_RMP: "SYNC_FACEBOOK_SETTING_WITH_RMP",
  CHANGE_FACEBOOK_SETTING_PAGE: "CHANGE_FACEBOOK_SETTING_PAGE",
  RWIDGET_CONVERSION_DEFAULT_VALUE: "RWIDGET_CONVERSION_DEFAULT_VALUE",
  GET_RWIDGET_CONVERSION_DEFAULT_VALUE: "GET_RWIDGET_CONVERSION_DEFAULT_VALUE",
  // GET_FACEBOOK_LEAD_SOURCE_DATA: "GET_FACEBOOK_LEAD_SOURCE_DATA",
  GET_FACEBOOK_CONVERSION_SET_ALL: "GET_FACEBOOK_CONVERSION_SET_ALL",
  SET_FACEBOOK_CONVERSION_SET_ALL: "SET_FACEBOOK_CONVERSION_SET_ALL",
  GET_FACEBOOK_PAGE_ID: "GET_FACEBOOK_PAGE_ID",
  GET_FACEBOOK_FORM_LIST: "GET_FACEBOOK_FORM_LIST",
  GET_ALL_LEAD_FORM_SETTINGS: "GET_ALL_LEAD_FORM_SETTINGS",
  SET_FACEBOOK_ACCOUNT: "SET_FACEBOOK_ACCOUNT",
  GET_FACEBOOK_ACCOUNT: "GET_FACEBOOK_ACCOUNT",
  SWITCH_LEAD_FORM_STATUS: "SWITCH_LEAD_FORM_STATUS",
  GET_LEAD_FORM_SETTING: "GET_LEAD_FORM_SETTING",
  GET_FACEBOOK_PAGE_SETTING: "GET_FACEBOOK_PAGE_SETTING",
  GET_GOOGLE_SETTING: "GET_GOOGLE_SETTING",
  GET_CRM_SETTING: "GET_CRM_SETTING",
  SET_LEAD_FORM_SETTING: "SET_LEAD_FORM_SETTING",
  GET_PAGE_SETTING: "GET_PAGE_SETTING",
  GET_FACEBOOK_USER_INFO: "GET_FACEBOOK_USER_INFO",
  GET_FACEBOOK_NEW_ACCESS_TOKEN: "GET_FACEBOOK_NEW_ACCESS_TOKEN",
  GET_FACEBOOK_PAGE_ACCESS_TOKEN: "GET_FACEBOOK_PAGE_ACCESS_TOKEN",
  GET_FACEBOOK_PAGE_BY_USER_ID: "GET_FACEBOOK_PAGE_BY_USER_ID",
  CHANGE_PAGE_URL_INPUT: "CHANGE_PAGE_URL_INPUT",
  CHANGE_PAGE_FORM_SELECT_TYPE: "CHANGE_PAGE_FORM_SELECT_TYPE",
  SET_CHECKED_FORM_ITEMS: "SET_CHECKED_FORM_ITEMS",
  SET_FB_CONNECTED: "SET_FB_CONNECTED",
  SET_FB_DISCONNECTED: "SET_FB_DISCONNECTED",
  SET_GOOGLE_CONNECTED: "SET_GOOGLE_CONNECTED",
  SET_GOOGLE_DISCONNECTED: "SET_GOOGLE_DISCONNECTED",
  ARCHIVE_LEAD_FORM_SETTING: "ARCHIVE_LEAD_FORM_SETTING",
  CHANGE_SHEETS_URL_INPUT: "CHANGE_SHEETS_URL_INPUT",
  GET_FACEBOOK_PAGE_LIST: "GET_FACEBOOK_PAGE_LIST",
  GET_USER_ACCESS_TOKEN: "GET_USER_ACCESS_TOKEN",
  GET_FACEBOOK_PAGE_LIST_MORE: "GET_FACEBOOK_PAGE_LIST_MORE",
  SET_VALIDATE_FACEBOOK_LEAD_FORM: "SET_VALIDATE_FACEBOOK_LEAD_FORM",
  SET_DUPLICATE_FACEBOOK_FORM: "SET_DUPLICATE_FACEBOOK_FORM",
  GET_GOOGLE_SHEETS_CRM_CONVERSIONS_LAST_SEND: "GET_GOOGLE_SHEETS_CRM_CONVERSIONS_LAST_SEND",
  GET_DETAILS_PIXEL_ID: "GET_DETAILS_PIXEL_ID",
  UPDATE_SHEETS_MODIFIED_DATA: "UPDATE_SHEETS_MODIFIED_DATA",
  UPDATE_FB_LEAD_FORM_SETTING_ERROR_STATUS: "UPDATE_FB_LEAD_FORM_SETTING_ERROR_STATUS",
  SET_FILE_INFO_ERROR: "SET_FILE_INFO_ERROR",
  SET_FACEBOOK_LOADING: "SET_FACEBOOK_LOADING",
  SET_FACEBOOK_FORM_LOADING: "SET_FACEBOOK_FORM_LOADING",
  SET_FACEBOOK_ERROR: "SET_FACEBOOK_ERROR",
  SET_FB_CONNECTION_LOADING: "SET_FB_CONNECTION_LOADING",
  SET_CRM_CONVERSIONS_LOADING: "SET_CRM_CONVERSIONS_LOADING",
};
